import styled from 'styled-components'

export const MainContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.whiteLabel.spacing.sp24};
`

export const InfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.whiteLabel.spacing.sp16};
`

export const OrdersContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.whiteLabel.spacing.sp16};
`

export const OrderContainer = styled.a`
  text-decoration: none;
  color: inherit;
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.whiteLabel.spacing.sp8};
  padding: ${props => props.theme.whiteLabel.spacing.sp8};
  border-radius: 8px;
  background-color: ${props => props.theme.colors.grey.tone50};
  cursor: pointer;
`

export const OrderHeaderContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  justify-content: space-between;
`

export const OrderNameContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: ${props => props.theme.whiteLabel.spacing.sp8};
`

export const ProductsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.whiteLabel.spacing.sp16};
`

export const ProductsList = styled.ul`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.whiteLabel.spacing.sp4};
  margin: 0px;
  margin-top: 4px;
  padding-left: ${props => props.theme.whiteLabel.spacing.sp16};
  margin-left: ${props => props.theme.whiteLabel.spacing.sp4};
  color: ${props => props.theme.colors.grey.tone500};
`
